export default __webpack_public_path__ + "static/MachuPicchustrailblazingwomen-dac6533057b5055785225cb7b62110c3.jpg";